export default class ExternalURL {
	constructor() {
		this.node = document.querySelectorAll('a');

		if (!this.node) {
			return;
		}

		const website = window.location.hostname;

		const internalLinkRegex = new RegExp('^((((http:\\/\\/|https:\\/\\/)(www\\.)?)?'
			+ website
			+ ')|(localhost:\\d{4})|(\\/.*))(\\/.*)?|(#.*)$', '');

		// console.log(website);
		// console.log(internalLinkRegex);
		this.node.forEach((node) => {
			var href = node.getAttribute('href');

			if (!internalLinkRegex.test(href)) {
				node.setAttribute('target', '_blank');
				node.setAttribute('rel', 'noreferrer nofollow');
			}
		});

		//var anchorEls = document.querySelectorAll('a');
		//var anchorElsLength = anchorEls.length;

		// for (var i = 0; i < anchorElsLength; i++) {
		// 	var anchorEl = anchorEls[ i ];
		// 	var href = anchorEl.getAttribute('href');

		// 	if (!internalLinkRegex.test(href) || !href.startsWith('#')) {
		// 		anchorEl.setAttribute('target', '_blank');
		// 	}
		// }

	}
}





